// Interaktywny kalendarz sekcji „Laureaci" (strona główna).
// Dane czyta z <script data-winners-json> (App\Service\WinnersProvider).
// Model: wybór DNIA. Nagrody II, III i IV stopnia wiszą na etapach dziennych, więc trafiają
// dokładnie na swój dzień; „Nagroda tygodnia" (I stopnia) wisi na etapie tygodniowym i towarzyszy
// każdemu dniu swojego tygodnia. Dzień bez czegokolwiek → komunikat „brak laureatów".
// Bloki „Nagroda tygodnia" i lista nagród IV stopnia znikają, gdy nie ma dla nich laureatów.
// Obsługa: zmiana miesiąca (‹ ›), klik dnia, stan pusty.

const MONTHS = [
	'STYCZEŃ', 'LUTY', 'MARZEC', 'KWIECIEŃ', 'MAJ', 'CZERWIEC',
	'LIPIEC', 'SIERPIEŃ', 'WRZESIEŃ', 'PAŹDZIERNIK', 'LISTOPAD', 'GRUDZIEŃ',
];

const pad = (n) => String(n).padStart(2, '0');
const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const parseYMD = (s) => {
	const [y, m, d] = s.split('-').map(Number);
	return new Date(y, m - 1, d);
};
const monthKey = (d) => d.getFullYear() * 12 + d.getMonth();
const esc = (s) => String(s).replace(/[&<>"']/g, (c) => (
	{ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[c]
));

function initWinners(root) {
	const jsonEl = root.querySelector('[data-winners-json]');
	if (!jsonEl) return;

	let data;
	try {
		data = JSON.parse(jsonEl.textContent);
	} catch (e) {
		return;
	}

	const weeks = (data.weeks || []).map((w) => ({
		...w,
		startD: parseYMD(w.start),
		endD: parseYMD(w.end),
	}));
	if (!weeks.length) return;

	const weekWinners = data.weekWinners || {};
	const daily = data.daily || {};
	// Nagrody IV stopnia (100 zł) wiszą — jak II i III — na etapie DZIENNYM, więc lista jest
	// per dzień, nie per tydzień. Per tydzień zostaje wyłącznie „Nagroda tygodnia".
	const hundred = data.hundred || {};
	// Nazwa nagrody IV stopnia idzie z backendu (Prize::$shortName), żeby zmiana w konfiguracji
	// nagród była widoczna na froncie bez ruszania tego pliku.
	const hundredLabel = data.hundredLabel || '100 zł';

	const daysEl = root.querySelector('[data-days]');
	const monthNameEl = root.querySelector('[data-month-name]');
	const pillEl = root.querySelector('[data-week-pill]');
	const panelEl = root.querySelector('[data-panel]');
	const prevBtn = root.querySelector('[data-nav="prev"]');
	const nextBtn = root.querySelector('[data-nav="next"]');

	const minMonth = monthKey(parseYMD(data.minDate));
	const maxMonth = monthKey(parseYMD(data.maxDate));

	let selectedDate = data.selected || weeks[0].start;
	let view = parseYMD(selectedDate);
	let viewYear = view.getFullYear();
	let viewMonth = view.getMonth();

	const weekOf = (date) => {
		const t = date.getTime();
		return weeks.find((w) => t >= w.startD.getTime() && t <= w.endD.getTime());
	};

	function renderCalendar() {
		monthNameEl.textContent = `${MONTHS[viewMonth]} ${viewYear}`;

		const selWeek = weekOf(parseYMD(selectedDate));
		const firstDay = new Date(viewYear, viewMonth, 1);
		const offset = (firstDay.getDay() + 6) % 7; // poniedziałek = 0
		const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();

		const frag = document.createDocumentFragment();

		for (let i = 0; i < offset; i++) {
			const empty = document.createElement('span');
			empty.className = 's-winners__day s-winners__day--empty';
			empty.setAttribute('aria-hidden', 'true');
			frag.appendChild(empty);
		}

		for (let day = 1; day <= daysInMonth; day++) {
			const date = new Date(viewYear, viewMonth, day);
			const iso = ymd(date);
			const week = weekOf(date);

			let cls = 's-winners__day';
			if (week) {
				cls += ' s-winners__day--pick';
				if (iso === selectedDate) {
					cls += ' s-winners__day--hot';
				} else if (selWeek && week.id === selWeek.id) {
					cls += ' s-winners__day--week';
				}
			}

			let cell;
			if (week) {
				cell = document.createElement('button');
				cell.type = 'button';
				cell.dataset.date = iso;
				cell.setAttribute('aria-label', `${day} ${MONTHS[viewMonth].toLowerCase()}`);
				if (iso === selectedDate) cell.setAttribute('aria-current', 'date');
			} else {
				cell = document.createElement('span');
			}
			cell.className = cls;
			cell.textContent = String(day);
			frag.appendChild(cell);
		}

		daysEl.replaceChildren(frag);

		prevBtn.disabled = monthKey(new Date(viewYear, viewMonth, 1)) <= minMonth;
		nextBtn.disabled = monthKey(new Date(viewYear, viewMonth, 1)) >= maxMonth;
	}

	function renderPanel() {
		const week = weekOf(parseYMD(selectedDate));
		pillEl.textContent = week ? week.label : '';

		const weekPrize = week ? ((weekWinners[week.id] || {}).weekPrize || null) : null;
		const dayDaily = daily[selectedDate] || [];
		const dayHundred = hundred[selectedDate] || [];

		// Stan pusty dopiero, gdy na ten dzień nie ma NIC — ani nagród dziennych, ani listy
		// 100 zł, ani nagrody tygodnia (ta towarzyszy każdemu dniu swojego tygodnia).
		if (!weekPrize && !dayDaily.length && !dayHundred.length) {
			panelEl.innerHTML = `
				<div class="s-winners__empty">
					<p class="s-winners__empty-title">Brak laureatów</p>
					<p class="s-winners__empty-text">W tym dniu nie ma jeszcze laureatów — wyniki pojawią się po weryfikacji.</p>
				</div>`;
			return;
		}

		const dailyRows = dayDaily.map((p) => `
			<div class="s-winners__prize">
				<span class="s-winners__prize-title">${esc(p.title)}</span>
				<span class="s-winners__prize-winner">${esc(p.winner)}</span>
			</div>`).join('');

		// „Brak nagród dziennych" tylko wtedy, gdy tego dnia nie ma NICZEGO dziennego. Lista 100 zł
		// to też nagroda dzienna (IV stopnia), więc komunikat o ich braku nie może wisieć nad nią.
		const dailyBlock = dailyRows || (dayHundred.length
			? ''
			: '<p class="s-winners__daily-none">Brak nagród dziennych tego dnia.</p>');

		const weekBlock = weekPrize ? `
			<div class="s-winners__weekprize">
				<p class="s-winners__weekprize-label">Nagroda tygodnia</p>
				<div class="s-winners__weekprize-row">
					<span class="s-winners__weekprize-amount">${esc(weekPrize.amount)}</span>
					<span class="s-winners__weekprize-winner">${esc(weekPrize.winner)}</span>
				</div>
			</div>` : '';

		const hundredList = dayHundred;
		const listId = `winnersList-${selectedDate}`;
		const accBlock = hundredList.length ? `
			<div class="s-winners__acc">
				<a class="s-winners__acc-head collapsed" data-bs-toggle="collapse" href="#${listId}" role="button" aria-expanded="false" aria-controls="${listId}">
					<span class="s-winners__acc-titles">
						<span class="s-winners__acc-title">${hundredList.length} × ${esc(hundredLabel)}</span>
						<span class="s-winners__acc-sub">Rozwiń listę laureatów</span>
					</span>
					<span class="s-winners__toggle" aria-hidden="true">
						<svg class="s-winners__chevron" width="24" height="24" viewBox="0 0 24 24" fill="none">
							<path d="M7.4 15.375L6 13.975L12 7.975L18 13.975L16.6 15.375L12 10.8L7.4 15.375Z" fill="currentColor"/>
						</svg>
					</span>
				</a>
				<div id="${listId}" class="collapse s-winners__acc-body">
					<ul class="s-winners__winners">${hundredList.map((n) => `<li>${esc(n)}</li>`).join('')}</ul>
				</div>
			</div>` : '';

		panelEl.innerHTML = `
			<div class="s-winners__panel">
				${weekBlock}
				<p class="s-winners__daily-title">Nagrody dzienne</p>
				${dailyBlock}
				${accBlock}
			</div>`;
	}

	function selectDate(iso) {
		if (!weekOf(parseYMD(iso))) return;
		selectedDate = iso;
		renderCalendar();
		renderPanel();
	}

	daysEl.addEventListener('click', (e) => {
		const btn = e.target.closest('[data-date]');
		if (btn) selectDate(btn.dataset.date);
	});

	prevBtn.addEventListener('click', () => {
		if (prevBtn.disabled) return;
		const d = new Date(viewYear, viewMonth - 1, 1);
		viewYear = d.getFullYear();
		viewMonth = d.getMonth();
		renderCalendar();
	});

	nextBtn.addEventListener('click', () => {
		if (nextBtn.disabled) return;
		const d = new Date(viewYear, viewMonth + 1, 1);
		viewYear = d.getFullYear();
		viewMonth = d.getMonth();
		renderCalendar();
	});

	renderCalendar();
	renderPanel();
}

function boot() {
	document.querySelectorAll('[data-winners]').forEach(initWinners);
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', boot);
} else {
	boot();
}
